import { z } from "zod/v4";

export const GetCogsDataRequestBodySchema = z.object({
  email: z.string(),
  query: z.string().nullish(),
  sync: z.boolean().nullish(),
});

export type GetCogsDataRequestBodyType = z.infer<
  typeof GetCogsDataRequestBodySchema
>;
